const current = [
  {
    path: '/project/current/detail/:id',
    component: () => import('@/page/project/current/Detail.vue'),
    meta: {
      name: '상세페이지',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/project/register',
    component: () => import('@/page/project/Register.vue'),
    meta: {
      name: '프로젝트 추가',
      isActive: false,
      isBread: true,
    },
  },
];

export default current;
